<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="RELATÓRIO DE COMPRAS SINTÉTICO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="5" :totalPDF="total" :totalHide="true" titleReport="Relatório de Pagamentos">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-10 md-xsmall-size-100">
                        <md-field>
                            <label for="pages">Situação</label>
                            <md-select v-model="dados.situacao_id" name="pages">
                                <md-option value="1">ATIVO</md-option>
                                <md-option value="2">INATIVO</md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                            <label>Data Inicial</label>
                        </md-datepicker>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                            <label>Data Final</label>
                        </md-datepicker>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-field>
                            <label>Pesquisar</label>
                            <md-input type="search" class="mb-3" clearable placeholder="NOME, CPF OU EMPRESA" v-model="buscar.busca">
                            </md-input>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-10 md-xsmall-size-100">
                        <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                            <md-icon>search</md-icon>
                        </md-button>
                    </div>

                    <div class="md-layout-item md-size-20 md-xsmall-size-100 ml-auto">
                        <md-field md-clearable class="md-toolbar-section-end">
                            <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                        </md-field>
                    </div>
                </div>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="CLIENTE" style="width: 30%">{{ item.cliente }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CPF" style="width: 15%">{{ item.cpf_cnpj }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CONTRATO" style="width: 10%">{{ item.contrato }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 30%">{{ item.empresa }}</md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 15%">{{ item.valor }}</md-table-cell>
                        <md-table-cell v-if="item.data_pagamento == 'TOTAL'" md-label="VALOR" style="width: 15%"><strong>{{ item.valor }}</strong></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1,
                tipo: 2
            },
            permissoes: this.$store.state.usuario.permissao,
            columnsPDF: [60, 30, 23, 45, 22],
            headRowsPDF: ['FUNCIONÁRIO', 'CPF', 'CONTRATO', 'EMPRESA', 'VALOR'],
            bodyRowsPDF: ['cliente', 'cpf_cnpj', 'contrato', 'empresa', 'valor'],
            fildsTXT: ['empresa', 'cliente', 'cpf_cnpj', 'unidade', 'contrato', 'valor_decimal'],
            columnsExcel: [

                {
                    label: "CLIENTE",
                    field: "cliente",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CPF",
                    field: "cpf_cnpj"
                },
                {
                    label: "CONTRATO",
                    field: "contrato"
                },
                {
                    label: "UNIDADE",
                    field: "unidade"
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "VALOR",
                    field: "valor_decimal"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    watch: {
        'dados.situacao_id': function (value) {
            this.read()
            this.titleInactivate = value == 1 ? 'INATIVAR?' : 'ATIVAR?'
            this.titleReport = value == 1 ? 'Relatório de Clientes Ativos.' : 'Relatório de Clientes Inativos.'
        },
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            this.buscar.situacao_id = this.dados.situacao_id
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'pagamentos/rh-sintetico'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.cliente, item.cpf_cnpj, item.fornecedor, item.empresa,
                    item.data_pagamento, item.valor
                ]).includes(this.toLower(term)))
            }
            return items
        },
    },

};
</script>
